import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "v1-screen" }
const _hoisted_2 = { class: "v1-screen__content" }
const _hoisted_3 = {
  key: 1,
  class: "v1-screen__subtitle"
}
const _hoisted_4 = { class: "v1-screen__dock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h1", {
            key: 0,
            class: _normalizeClass(["v1-screen__title", { 'v1-screen__title--center': _ctx.titleAlign === 'center' }]),
            "data-testid": "v1-screen-title"
          }, _toDisplayString(_ctx.title), 3))
        : _createCommentVNode("", true),
      (_ctx.$slots.subtitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "subtitle", {}, undefined, true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        variant: "primary",
        size: "lg",
        "full-width": "",
        disabled: _ctx.nextDisabled,
        loading: _ctx.nextLoading,
        "data-testid": "v1-screen-next",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('next')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.nextLabel || _ctx.t("continue")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ])
  ]))
}